<template>
  <BModal
    ref="license-expired-modal"
    :title="$t('app.common.licenseExpiredTitle')"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <div v-if="isLicenseExpired">
      {{ $t('app.common.licenseExpiredDescription') }}
    </div>
    <div v-if="!isLicenseExpired">
      {{ $t('app.common.licenseMissingDescription0') }}
    </div>
    <div v-if="!isLicenseExpired">
      {{ $t('app.common.licenseMissingDescription1') }}
    </div>

    <template #modal-footer>
      <BButton variant="primary" v-if="isLicenseExpired" @click="navigate">
        {{ $t('app.forms.updateLicense') }}
      </BButton>
      <BButton variant="secondary" @click="closeAndNavigate">
        {{
          isLicenseExpired
            ? $t('app.forms.rememberLater')
            : $t('app.forms.close')
        }}
      </BButton>
    </template>
  </BModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      isLicenseExpired: false,
    }
  },
  computed: {
    ...mapGetters({
      applications: 'applications/list',
    }),
  },
  methods: {
    ...mapActions({
      getApplications: 'applications/getApplications',
    }),
    async showModal() {
      await this.getApplications()
      if (this.applications && this.applications.length === 0) {
        this.isLicenseExpired = false
        this.$refs['license-expired-modal'].show()
      } else if (this.applications.every((app) => app.licensed === false)) {
        this.isLicenseExpired = true
        this.$refs['license-expired-modal'].show()
      }
    },
    navigate() {
      this.$router.push(this.localePath('/admin'))
    },
    closeAndNavigate() {
      if (this.isLicenseExpired) {
        this.$refs['license-expired-modal'].hide()
      } else {
        this.$router.push(this.localePath('/admin'))
      }
    },
  },
}
</script>
